var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBanking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.142,
    height: 24.848,
    viewBox: "0 0 25.142 24.848",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.73 15.434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.016,259.744a.945.945,0,1,1,1.08-.935.491.491,0,0,0,.982,0,1.954,1.954,0,0,0-1.571-1.862v-.255a.491.491,0,0,0-.982,0v.255a1.954,1.954,0,0,0-1.571,1.862,2,2,0,0,0,2.062,1.917.945.945,0,1,1-1.08.935.491.491,0,0,0-.982,0,1.954,1.954,0,0,0,1.571,1.862v.212a.491.491,0,0,0,.982,0v-.212a1.954,1.954,0,0,0,1.571-1.862A2,2,0,0,0,302.016,259.744Z",
    transform: "translate(-299.954 -256.201)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.853 13.695)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.242,223.146a6.4,6.4,0,0,0-2.614-2.313.491.491,0,1,0-.426.885,5.406,5.406,0,0,1,2.435,7.4.491.491,0,1,0,.867.461,6.391,6.391,0,0,0-.263-6.438Z",
    transform: "translate(-383.924 -220.785)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.04 13.116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.524,209h-.033a.491.491,0,0,0,0,.982h.031a.491.491,0,0,0,0-.982Z",
    transform: "translate(-347 -209.001)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.411 16.244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.049,280.838a5.406,5.406,0,0,1-2.435-7.4.491.491,0,1,0-.867-.461,6.387,6.387,0,0,0,2.876,8.751.491.491,0,1,0,.426-.885Z",
    transform: "translate(-212.002 -272.711)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.536 24.901)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.9,449h-.028a.491.491,0,0,0,0,.982h.033a.491.491,0,0,0,0-.982Z",
    transform: "translate(-316.378 -448.999)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.024,11.454a2.254,2.254,0,0,0-.218-.4h1.278a2.259,2.259,0,1,0,0-4.518H16.152A2.257,2.257,0,0,0,14.29,3H2.259a2.259,2.259,0,0,0,0,4.518H6.191a2.253,2.253,0,0,0,0,2.554H4.911a2.258,2.258,0,0,0-1.4,4.027,2.255,2.255,0,0,0,0,3.536,2.255,2.255,0,0,0,0,3.536,2.258,2.258,0,0,0,1.4,4.027H10.7a8.346,8.346,0,1,0,8.326-13.741Zm1.06-3.937a1.277,1.277,0,1,1,0,2.554H8.053a1.277,1.277,0,0,1,0-2.554ZM2.259,6.536a1.277,1.277,0,0,1,0-2.554H14.29a1.277,1.277,0,1,1,0,2.554Zm2.652,4.518H16.942a1.276,1.276,0,0,1,.557.128c-.232-.019-.467-.03-.7-.03a8.322,8.322,0,0,0-5.907,2.455H4.911a1.277,1.277,0,0,1,0-2.554Zm0,3.536h5.137a8.324,8.324,0,0,0-1.262,2.554H4.911a1.277,1.277,0,1,1,0-2.554Zm0,3.536H8.56a8.355,8.355,0,0,0-.03,2.554H4.911a1.277,1.277,0,0,1,0-2.554Zm0,6.089a1.277,1.277,0,0,1,0-2.554H8.73a8.315,8.315,0,0,0,1.178,2.554Zm11.884,2.652A7.366,7.366,0,1,1,24.16,19.5,7.374,7.374,0,0,1,16.794,26.866Z",
    transform: "translate(0 -3)",
    fill: "#0080ff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanking);
export default __webpack_public_path__ + "static/media/banking.775a163f.svg";
export { ForwardRef as ReactComponent };